import axios from "axios";
import { handleDemoRequest } from "../demo/handleDemoRequest";

// export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3020'
export const API_URL = '/'

/** Чи API на тому ж origin, що й сторінка (prod: API_URL='/'). */
export const isSameOriginApi = () => {
    const base = String(API_URL || '').replace(/\/$/, '');
    if (!base) return true;
    if (typeof window === 'undefined') return true;
    try {
        return new URL(base, window.location.origin).origin === window.location.origin;
    } catch {
        return false;
    }
};

/** Повний URL для <img src> та інших прямих запитів браузера (не через axios). */
export const resolveApiAssetUrl = (path) => {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    const rel = String(path).startsWith('/') ? path : `/${path}`;
    const base = String(API_URL || '').replace(/\/$/, '');
    if (!base) return rel;
    return `${base}${rel}`;
};

const API = axios.create({
    withCredentials: true,
    baseURL: API_URL,
})

const demoAdapter = async (config) => {
    const url = String(config.url || "").replace(/^\//, "");
    const method = config.method || "get";
    const body = config.data;

    const res = await handleDemoRequest({ method, url, body });
    return {
        data: res.data,
        status: res.status,
        statusText: res.statusText || "OK",
        headers: res.headers || {},
        config,
    };
};

API.interceptors.request.use((config) => {
    try {
        const isDemo = localStorage.getItem("isDemo") === "1"
        const url = String(config?.url || "")
        const isAuthEndpoint = url.includes("api/auth/login") || url.includes("api/auth/logout")
        const isInstitutionRegistryEndpoint =
            url.includes("api/institution/profile/") ||
            url.includes("api/institution/institutions")
        const isEQueueEndpoint = url.includes("api/institution/equeue/")

        // In demo mode we still keep real auth endpoints to preserve real menu/permissions.
        if (isDemo && !isAuthEndpoint && !isInstitutionRegistryEndpoint && !isEQueueEndpoint) {
            config.adapter = demoAdapter;
        }
    } catch (e) {
    }
    return config;
})
export default API;